(function () {
  const NOTE =
    '✓ Peru, siirrä tai ohita toimitus milloin vain — hallinnoit tilausta sähköpostilinkistä.';

  function getRechargeBlock(productInfo) {
    const widget = productInfo.querySelector('recharge-subscription-widget');
    const lightRoot = productInfo.querySelector('.rc-widget__root');
    const block =
      widget?.closest('.shopify-app-block') ||
      lightRoot?.closest('.shopify-app-block') ||
      null;
    return { block, widget, lightRoot };
  }

  function isSubscriptionSelected(widget, lightRoot) {
    const shadow = widget?.shadowRoot;
    if (shadow) {
      const input = shadow.querySelector('input[name="purchaseOption"][value="subscription"]');
      if (input) return input.checked;
      if (shadow.querySelector('.rc-purchase-option__subscription[rc-selected]')) return true;
    }

    if (lightRoot) {
      const input = lightRoot.querySelector('input[name="purchaseOption"][value="subscription"]');
      if (input) return input.checked;
      if (lightRoot.querySelector('.rc-purchase-option__subscription[rc-selected]')) return true;
    }

    return false;
  }

  function initProductInfo(productInfo) {
    const { block, widget, lightRoot } = getRechargeBlock(productInfo);
    if (!block || block.dataset.oskuRcBound === 'true') return;

    let note = block.querySelector('.osku-rc-subscription-note');
    if (!note) {
      note = document.createElement('p');
      note.className = 'osku-rc-subscription-note';
      note.textContent = NOTE;
      note.hidden = true;
      block.appendChild(note);
    }

    function sync() {
      const active = isSubscriptionSelected(widget, lightRoot);
      note.hidden = !active;
      block.classList.toggle('osku-rc-subscription-active', active);
    }

    block.dataset.oskuRcBound = 'true';
    block.addEventListener('change', sync, true);
    block.addEventListener('click', sync, true);

    const observeRoot = (root) => {
      if (!root) return;
      const observer = new MutationObserver(sync);
      observer.observe(root, {
        attributes: true,
        subtree: true,
        attributeFilter: ['checked', 'rc-selected'],
      });
    };

    observeRoot(widget?.shadowRoot);
    observeRoot(lightRoot);

    if (widget && !widget.shadowRoot) {
      const waitForShadow = new MutationObserver(() => {
        if (widget.shadowRoot) {
          observeRoot(widget.shadowRoot);
          waitForShadow.disconnect();
          sync();
        }
      });
      waitForShadow.observe(widget, { childList: true, subtree: true });
    }

    sync();
  }

  function init() {
    document.querySelectorAll('.product-info').forEach(initProductInfo);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', init);
})();
